export const SET_TIERS = 'SET_TIERS';
export const SET_TIER_INSTRUCTIONS = 'SET_TIER_INSTRUCTIONS';